import SearchField from './SearchField';
var SearchFieldWithMap = null;

try {
  // Only provide component if react-openlayers is present in parent project
  var _require = require('@avinet/react-openlayers'),
      withMapContext = _require.withMapContext;
  /**
   * Search field with awareness of surrounding Map. Using this instead of plain `SearchField` is required when prop
   * `zoomOnSelect` is set.
   */


  SearchFieldWithMap = withMapContext(SearchField);
} catch (ex) {}

export default SearchFieldWithMap;